import React, { useState, useEffect } from "react";
import axios from "axios";

export default function CreateProjectModal({ onClose, fetchProjects }) {
    const [clients, setClients] = useState([]);
    const [formData, setFormData] = useState({
        valor: '',
        data_inicio: '',
        data_termino: '',
        status: 'NOVO',
        cliente_id: '', // ID do cliente
    });

    const [errors, setErrors] = useState({
        valor: '',
        data_inicio: '',
        data_termino: '',
        cliente_id: '', // Verifica se o ID do cliente foi selecionado
    });

    useEffect(() => {
        // Carrega os clientes da base de dados
        axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`)
            .then(response => setClients(response.data))
            .catch(error => console.error('Error loading clients', error));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Função de validação
    const validateForm = () => {
        let isValid = true;
        const newErrors = { valor: '', data_inicio: '', data_termino: '', cliente_id: '' };

        if (!formData.valor.trim() || isNaN(formData.valor) || formData.valor <= 0) {
            newErrors.valor = 'O valor é obrigatório e deve ser um número válido.';
            isValid = false;
        }

        if (!formData.data_inicio) {
            newErrors.data_inicio = 'A data de início é obrigatória.';
            isValid = false;
        }

        if (!formData.data_termino) {
            newErrors.data_termino = 'A data de término é obrigatória.';
            isValid = false;
        }

        if (!formData.cliente_id) {
            newErrors.cliente_id = 'O cliente é obrigatório.';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Valida os campos
        if (validateForm()) {
            try {
                // Envia os dados para a API
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/projectRoutes/projects`, formData, {
                    headers: { 'Content-Type': 'application/json' }
                });
                // Verificando a resposta HTTP
                if (response.status === 201) {
                    fetchProjects(); // Atualiza a tela
                    onClose(); // Fecha o modal
                } else {
                    throw new Error('Erro ao criar o projeto');
                }
            } catch (error) {
                alert('Erro ao criar projeto');
            }
        }

    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-96">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Cadastrar Novo Projeto</h2>
                <form onSubmit={handleSubmit}>
                    {/* Cliente - Select */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Cliente</label>
                        <select
                            name="cliente_id"
                            value={formData.cliente_id}
                            onChange={handleChange}
                            className={`glass-input w-full ${errors.cliente_id ? 'border-red-500' : ''}`}
                        >
                            <option value="">Selecione um cliente</option>
                            {clients.map((client) => (
                                <option key={client.id} value={client.id}>
                                    {client.nome}
                                </option>
                            ))}
                        </select>
                        {errors.cliente_id && <p className="text-red-500 text-sm">{errors.cliente_id}</p>}
                    </div>
                    {/* Valor */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Valor</label>
                        <input
                            type="number"
                            name="valor"
                            value={formData.valor}
                            onChange={handleChange}
                            autoComplete="off"
                            className={`glass-input w-full ${errors.valor ? 'border-red-500' : ''}`}
                        />
                        {errors.valor && <p className="text-red-500 text-sm">{errors.valor}</p>}
                    </div>

                    {/* Data de Início */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Data de Início</label>
                        <input
                            type="date"
                            name="data_inicio"
                            value={formData.data_inicio}
                            onChange={handleChange}
                            className={`glass-input w-full ${errors.data_inicio ? 'border-red-500' : ''}`}
                        />
                        {errors.data_inicio && <p className="text-red-500 text-sm">{errors.data_inicio}</p>}
                    </div>

                    {/* Data de Término */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Data de Término</label>
                        <input
                            type="date"
                            name="data_termino"
                            value={formData.data_termino}
                            onChange={handleChange}
                            className={`glass-input w-full ${errors.data_termino ? 'border-red-500' : ''}`}
                        />
                        {errors.data_termino && <p className="text-red-500 text-sm">{errors.data_termino}</p>}
                    </div>

                    {/* Status */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Status</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            className="glass-input w-full"
                        >
                            <option value="Novo">Novo</option>
                            <option value="Em Andamento">Em Andamento</option>
                            <option value="Concluído">Concluído</option>
                        </select>
                    </div>

                    {/* Botões */}
                    <div className="flex justify-end space-x-2 mt-10">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-red-500 text-white py-1 px-3 rounded-md hover:bg-red-600"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
                        >
                            Cadastrar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
